import { render, staticRenderFns } from "./ServiceTypeCategoriesAutocomplete.vue?vue&type=template&id=62b3aba1"
import script from "./ServiceTypeCategoriesAutocomplete.vue?vue&type=script&lang=js"
export * from "./ServiceTypeCategoriesAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports